<template>
	<div class="c-breadcrumbs">
		<transition name="fade" tag="div">
			<div class="c-breadcrumbs__inner" v-if="active">
				<div
					v-for="(breadcrumb, i) in breadcrumbs"
					:key="breadcrumb._id"
					class="c-breadcrumbs__item-container"
					tabindex="0"
					@click="onClick(breadcrumb)"
				>
					<div class="c-breadcrumbs__item hook-item" :data-id="breadcrumb._id">
						<span v-if="breadcrumb.root"> Home </span>
						<span v-else>
							{{ breadcrumb.content.title }}
						</span>
					</div>
					<chevron-right-icon
						size="1x"
						v-if="i !== breadcrumbs.length - 1"
					></chevron-right-icon>
				</div>
			</div>
		</transition>
		<!-- <settings-icon size="1x" class="custom-class"></settings-icon> -->
		<menu-icon size="1x" @click="onMenuClick"></menu-icon>
	</div>
</template>

<script>
import { ChevronRightIcon, SettingsIcon, MenuIcon } from 'vue-feather-icons';

export default {
	components: {
		ChevronRightIcon,
		SettingsIcon,
		MenuIcon,
	},

	props: {
		currentBlock: Object,
	},

	computed: {
		active: function () {
			if (this.breadcrumbs.length < 2) {
				return false;
			} else {
				return true;
			}
		},
		blocks: function () {
			return this.$store.getters['block/blocks'];
		},
		breadcrumbs: function () {
			let currentBlock = this.currentBlock;
			if (currentBlock.root) {
				return [currentBlock];
			}
			let blocks = this.goUp([currentBlock]);
			blocks = blocks.reverse();
			return blocks;
		},
	},

	methods: {
		onMenuClick: function () {
			this.$store.dispatch('settings/showSettings');
		},
		goUp: function (blocksArray) {
			let parentBlock = blocksArray[blocksArray.length - 1].parent;
			parentBlock = this.find(parentBlock);
			if (parentBlock.root) {
				return blocksArray.concat(parentBlock);
			} else {
				return this.goUp(blocksArray.concat(parentBlock));
			}
		},
		find: function (blockId) {
			let block = null;
			for (let i = 0; i < this.blocks.length; i++) {
				if (this.blocks[i]._id === blockId) {
					block = this.blocks[i];
					break;
				}
			}
			return block;
		},

		onClick: function (block) {
			this.$router.push({
				path: `/f/${block._id}`,
			});
		},
	},
};
</script>

<style lang="scss">
.c-breadcrumbs {
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 0 var(--margin-lg);
	// while we do want to animate height, we also dont want to resize the viewport so we hardcode the height here
	height: var(--spacer-lg);
	&__inner {
		padding: var(--margin);
		padding-left: 0;
		height: var(--spacer-lg);
		display: flex;
		align-items: center;

		svg {
			margin-left: var(--margin);
		}
	}

	&__item-container {
		display: flex;
		align-items: center;
	}

	&__item {
		position: relative;
		font-size: var(--font-size-sm);
		border-radius: var(--border-radius);

		padding: var(--margin) var(--margin-lg);
		cursor: pointer;
		user-select: none;

		&:hover,
		&:active {
			background-color: var(--g1);
		}

		&:focus-visible {
			outline: none;
			@include focus();
		}
	}

	.fade-enter-active,
	.fade-leave-active {
		transition: all var(--transition-time) ease-in-out;
	}
	.fade-enter, .fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
		transform: translateY(-4px);
		opacity: 0;
	}
}
</style>